module.exports = __webpack_public_path__ + "static/img/produto_g.f26005e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_guarana/produto_g.png
// module id = ng2m
// module chunks = 0